import apiClient from '@/lib/api/client';
import {
  LoginApiResponse,
  LoginPayload,
  ForgotPasswordPayload,
  ResetPasswordPayload,
} from '@/types/auth.types';

export const authService = {
  async login(payload: LoginPayload): Promise<LoginApiResponse> {
    const response = await apiClient.post<LoginApiResponse>('/auth/login', payload);
    return response.data;
  },

  async forgotPassword(payload: ForgotPasswordPayload): Promise<{ message?: string }> {
    const response = await apiClient.post<{ message?: string }>('/auth/forgot-password', payload);
    return response.data;
  },

  async resetPassword(payload: ResetPasswordPayload): Promise<{ message?: string }> {
    const response = await apiClient.post<{ message?: string }>('/auth/reset-password', payload);
    return response.data;
  },

  getStoredToken(): string | null {
    return localStorage.getItem('pfg_token');
  },

  setStoredToken(token: string): void {
    localStorage.setItem('pfg_token', token);
  },

  removeStoredToken(): void {
    localStorage.removeItem('pfg_token');
  },
};
